import React, { FC } from 'react'
import t from '../../../../../translations/main'
import { Trans } from 'react-i18next'

import Button from '../../../../../components/Atoms/Button/Button'

import {
  FormStyle,
  FormHeader,
  FormTitle,
  FormDescription,
  FormFooter,
  FormFooterActionsLeft,
  FormFooterActionsRight,
} from '../../../../../components/Organisms/Form/Form.styles'

import { FormProps } from '../../../../Pages/Onboarding/types'
import Table from 'src/components/Organisms/Table/Table'
import Font from 'src/components/Core/Typography/Font/Font'
import { ExternalLink } from 'src/components/Core/Styles/Link'

const CCPClearingServicesForm: FC<FormProps> = props => {

  const { submit } = props

  const lchLink = <ExternalLink href='https://www.lchclearnet.com' />
  const lmeLink = <ExternalLink href='https://www.lme.com/trading/post-trade-services/lme-clear/' />
  const iceLink = <ExternalLink href='https://www.theice.com/clear_europe.jhtml' />
  const tableColumns = [
    {Header: t('onboarding.forms.CorporateAccount.CCPClearingServicesForm.tableHeaders.agreedCCP'), accessor: 'agreedCCP'},
    {Header: t('onboarding.forms.CorporateAccount.CCPClearingServicesForm.tableHeaders.agreedCCPService'), accessor: 'agreedCCPService'},
    {Header: t('onboarding.forms.CorporateAccount.CCPClearingServicesForm.tableHeaders.mandatoryCCPProvisions'), accessor: 'mandatoryCCPProvisions'},
    {Header:  t('onboarding.forms.CorporateAccount.CCPClearingServicesForm.tableHeaders.excludedTransactionType'), accessor: 'excludedTransactionType'},
    {Header:  t('onboarding.forms.CorporateAccount.CCPClearingServicesForm.tableHeaders.typeOfClient'), accessor: 'typeOfClient'},
    {Header:  t('onboarding.forms.CorporateAccount.CCPClearingServicesForm.tableHeaders.typeOfClientAccount'), accessor: 'typeOfClientAccount'},
  ]

  const clearingServicesTableData = [
    {
      agreedCCP: 'LCH.Clearnet Ltd',
      agreedCCPService: 'LCH EnClear OTC Service (for freight derivatives)',
      mandatoryCCPProvisions: 'Schedule 2 to LCH Clearnet Ltd Procedures Section 4 (Margin and Collateral) as amended and supplemented from time to time. End User Notice.',
      excludedTransactionType: 'As agreed between the parties from time to time',
      typeOfClient: 'Omnibus Client Account',
      typeOfClientAccount: 'Net Omnibus',
    },
    {
      agreedCCP: 'ICE Clear Europe Limited',
      agreedCCPService: 'Futures & Options',
      mandatoryCCPProvisions: 'Exhibit 2 to ICE Clear Europe Clearing Rules (Customer CM F&O Transactions Standard Terms) as amended and supplemented from time to time',
      excludedTransactionType: 'As agreed between the parties from time to time',
      typeOfClient: 'Omnibus Client Account',
      typeOfClientAccount: 'Net Omnibus',
    },
    {
      agreedCCP: 'LME Clear Limited',
      agreedCCPService: 'LME Clearing Service (to include OTC London Bullion Market Forwards)',
      mandatoryCCPProvisions: 'The Mandatory CCP Provisions stipulated in Part B to Annex 6 of the Rules and Procedures of the Agreed CCP as amended and supplemented from time to time',
      excludedTransactionType: 'As agreed between the parties from time to time',
      typeOfClient: 'Omnibus Client Account',
      typeOfClientAccount: 'Net Omnibus',
    },
    {
      agreedCCP: 'The Trading Agreed CCP relating to the relevant Trading Agreed CCP Service ',
      agreedCCPService: 'Each Trading Agreed CCP Service ',
      mandatoryCCPProvisions: 'The Trading Mandatory CCP Provisions relating to the relevant Trading Agreed CCP Service',
      excludedTransactionType: 'As agreed between the parties from time to time ',
      typeOfClient: 'The Trading Type of Client Default Election',
      typeOfClientAccount: 'The Trading Type of Client Account Default Election',
    },
  ]

  return (
    <FormStyle onSubmit={() => submit({data: {}})}>
      <FormHeader>
        <FormTitle>
          {t('onboarding.forms.CorporateAccount.CCPClearingServicesForm.title')}
        </FormTitle>
        <FormDescription ellipsis={false}>
          {/* @ts-ignore-next-line */}
          <Trans i18nKey='onboarding.forms.CorporateAccount.CCPClearingServicesForm.description' />
        </FormDescription>
      </FormHeader>
      <Table tableData={clearingServicesTableData} tableColumns={tableColumns} removeCellEllipsis cellTag='h5' />
      <Font
        key='LinksText'
        ellipsis={false}
      >
        {/* @ts-ignore:next-line */}
        {<Trans i18nKey={'onboarding.forms.CorporateAccount.CCPClearingServicesForm.visualOnly.links'} components={{ lchLink, lmeLink, iceLink }} />}
      </Font>
      <FormFooter noOfButtons={2}>
        <FormFooterActionsLeft>
          <Button
            label={t('onboarding.main.backButton')}
            version={2}
            disabled={props.disablePrev}
            onClick={props.prevStep}
          />
        </FormFooterActionsLeft>
        <FormFooterActionsRight>
          <Button
            type='submit'
            label={props.isLastForm ? t('onboarding.main.saveAndSubmit') : t('onboarding.main.continueButton')}
          />
        </FormFooterActionsRight>
      </FormFooter>
    </FormStyle>
  )
}

export default CCPClearingServicesForm
